import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { FlightCheaperDatesCard } from './ui/flight_cheaper_dates_card.js';

/**
 * Entrada de catálogo do `flight_cheaper_dates` (slot chat). Interativo: o toque
 * numa data volta por `interaction` (challengeId + texto com as datas) — o shell
 * é só transporte; o LLM relê e busca.
 */
export const flightCheaperDatesEntry: GenUiEntry<
  Extract<ChatUi, { kind: 'flight_cheaper_dates' }>
> = {
  kind: 'flight_cheaper_dates',
  slot: 'chat',
  policy: { productOf: () => 'flight' },
  render: ({ ui, note, readOnly, dispatch }) => (
    <FlightCheaperDatesCard ui={ui} note={note} readOnly={readOnly} dispatch={dispatch} />
  ),
};
